<template>
  <div class="convention-hall page">
    <van-nav-bar class="nav-bar" :title="$t('concubine.concubine')">
      <template #right>
        <van-image
            width="18"
            height="18"
            src="/img/clm.png"
            style="margin-right: 10px"
            @click="isShow = false"
        />
        <van-image
            width="22"
            height="22"
            src="/img/row.png"
            @click="isShow = true"
        />
      </template>
    </van-nav-bar>

    <div class="content-wrap">
      <div class="area-tabs-wrap" v-if="tabList.length">
        <van-tabs
            v-model="active"
            swipeable
            animated
            title-active-color="#C571CF"
            color="#C571CF"
            line-height="6px"
            line-width="31px"
            @change="onTabChange"
        >
          <van-tab
              v-for="(item, index) in tabList"
              :key="item.id || index"
              :title="item.name"
          />
        </van-tabs>
      </div>

      <div class="list-wrap" v-if="tabList.length">
        <div v-if="loading" class="loadingBox">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </div>

        <!-- 宫格模式 -->
        <div class="pblBox" v-show="!isShow && !loading && data.length">
          <div
              class="gridItem"
              v-for="row in data"
              :key="row.id"
              @click="toDetail(row.id)"
          >
            <div class="releaseItem">
              <div class="imgBox">
                <div class="van-image" style="width: 100%; height: 100%">
                  <img :src="row.img_url" class="van-image__img" />
                </div>

                <span><i>{{ $t("concubine.high_end") }}</i></span>

                <div class="infoBox">
                  <i
                      class="van-icon van-icon-location"
                      style="font-size: 14px"
                  ></i>
                  <span style="font-size: 12px; margin-left: 2px"></span>
                  <div class="wantyuebtn">
                    {{ $t("concubine.appointment") }}
                  </div>
                </div>
              </div>

              <div class="tagBox">
                {{ $t("concubine.beautiful_girl") }}
              </div>

              <div class="di">
                <div>
                  <span class="dot"></span>
                  <span>{{ row.xuanfei_name }}</span>
                </div>
                <div>
                  <i
                      class="van-icon van-icon-like"
                      style="color: rgb(220, 99, 161)"
                  ></i>
                  <span>{{ row.dianzan }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 列表模式 -->
        <div
            class="horizontalItem"
            v-show="isShow && !loading"
            v-for="row in data"
            :key="row.id"
            @click="toDetail(row.id)"
        >
          <div class="imgBox">
            <div
                class="van-image"
                style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                  :src="row.img_url"
                  class="van-image__img"
                  style="object-fit: cover"
              />
            </div>
            <span><i>{{ $t("concubine.high_end") }}</i></span>
          </div>

          <div class="rightBox">
            <div class="top">
              <div>
                <div class="van-image" style="width: 13px">
                  <img
                      src="/img/vip.png"
                      style="width: 13px; height: 13px"
                      class="van-image__img"
                  />
                </div>
                <span>{{ $t("index.authentication") }}</span>
              </div>

              <div>
                <div class="van-image" style="width: 13px">
                  <img
                      src="/img/vip.png"
                      class="van-image__img"
                      style="width: 13px; height: 13px"
                  />
                </div>
                <span>{{ $t("index.video_authentication") }}</span>
              </div>

              <div class="nameEllipsis">
                {{ row.xuanfei_name }}
              </div>
            </div>

            <div class="tags">
              <van-tag
                  v-for="(tag, i) in row.flagArray"
                  :key="i"
                  :type="tagTypes[i % tagTypes.length]"
              >
                {{ tag }}
              </van-tag>
            </div>

            <div style="display: flex; align-items: center">
              <span style="font-size: 14px; color: rgb(102, 102, 102)">
                {{ $t("index.toll") }}：
              </span>
              <van-rate
                  v-model="row.number"
                  color="#ffd21e"
                  size="20px"
              />
            </div>

            <div class="desc">
              {{ $t("index.height") }}: {{ row.hight || "-" }}cm
              {{ $t("index.bust") }}：{{ row.bust || "-" }}
              {{ $t("index.address") }}：{{ row.address || "-" }}
              {{ $t("index.National") }}：{{ $t("index.yes") }}
            </div>

            <div class="yueta">{{ $t("index.about") }}</div>
          </div>
        </div>

        <div v-if="!loading && !data.length" class="emptyBox">暂无数据</div>
      </div>

      <div v-else class="emptyBox">暂无地区</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      loading: false,
      banners: [],
      basicData: [],
      active: 0,
      tabList: [],
      data: [],
      ids: "",
      tagTypes: ["primary", "success", "danger", "warning"],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        page: 0,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },

  methods: {
    // 地址数组兼容：
    // 1. 一维数组 -> 直接返回
    // 2. 二维数组 -> 合并所有数组
    normalizeAreaList(resData) {
      if (!Array.isArray(resData) || resData.length === 0) return [];

      if (Array.isArray(resData[0])) {
        let result = [];
        resData.forEach((item) => {
          if (Array.isArray(item)) {
            result = result.concat(item);
          }
        });

        // 去重，避免后端重复返回相同id
        const map = {};
        return result.filter((item) => {
          if (!item || map[item.id]) return false;
          map[item.id] = true;
          return true;
        });
      }

      return resData;
    },

    formatFlag(list) {
      const lang = localStorage.getItem("lang");
      (list || []).forEach((item) => {
        const parts = (item.flag || "").split("|");

        if (lang === "zh") {
          item.flag = parts[0] || "";
        } else if (lang === "en") {
          item.flag = parts[1] || "";
        } else if (lang === "ja") {
          item.flag = parts[2] || "";
        } else {
          item.flag = parts[3] || "";
        }

        item.flagArray = item.flag ? item.flag.split("，") : [];
        item.number = Number(item.number || 5);
      });
      return list;
    },

    getxuanfeilist() {
      if (!this.ids) {
        this.loading = false;
        this.data = [];
        return;
      }

      this.loading = true;

      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          id: this.ids
        },
      })
          .then((res) => {
            const raw = Array.isArray(res.data) ? res.data : [];
            this.data = this.formatFlag(raw);
            this.loading = false;
          })
          .catch(() => {
            this.data = [];
            this.loading = false;
          });
    },

    onTabChange(index) {
      const current = this.tabList[index];
      if (!current) return;

      this.active = index;
      this.ids = current.id || "";
      this.data = [];
      this.getxuanfeilist();
    },

    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },

    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      })
          .then((res) => {
            const list = this.normalizeAreaList(res.data);

            this.tabList = (list || []).map((item) => ({
              ...item,
              name: (item.name || "").split(",")[0],
            }));

            if (this.tabList.length > 0) {
              this.active = 0;
              this.ids = this.tabList[0].id || "";
              this.getxuanfeilist();
            } else {
              this.ids = "";
              this.data = [];
            }
          })
          .catch(() => {
            this.tabList = [];
            this.ids = "";
            this.data = [];
          });
    },

    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data || {};
        this.getBanner(this.basicData);
      });
    },

    getBanner(data) {
      this.banners = data && data.banners ? data.banners : [];
    },
  },

  created() {
    this.getAddress();
    this.getBasicConfig();
  },
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
  height: 100px;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}

.banner-wrap {
  height: 160px;
  overflow: hidden;
}

.banner_swiper {
  height: 160px;
}

.banner_img {
  width: 100%;
  height: 160px;
}

.content-wrap {
  background: #fff;
  padding-bottom: 40px;
}

.area-tabs-wrap {
  background: #fff;
  padding: 0 20px;
}

::v-deep .van-tabs__wrap {
  height: 74px;
}

::v-deep .van-tabs__nav {
  background: #fff;
}

::v-deep .van-tab {
  flex: none;
  padding: 0 18px;
  font-size: 22px;
  font-weight: 700;
  color: #555;
  line-height: 74px;
}

::v-deep .van-tab--active {
  color: #c571cf;
}

::v-deep .van-tabs__line {
  background-color: #c571cf;
  bottom: 12px;
}

::v-deep .van-tabs__content {
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}

.list-wrap {
  background: #fff;
}

.loadingBox {
  padding: 40px 0;
  display: flex;
  justify-content: center;
}

.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 8px 20px 20px;
  flex-wrap: wrap;
}

.gridItem {
  width: calc(50% - 6px);
}

.releaseItem {
  width: 100%;
  margin-bottom: 24px;
}

.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: 67vw;
}

.tagBox {
  font-size: 3vw;
  margin: 10px 0;
  color: rgb(102, 102, 102);
}

.di {
  display: flex;
  justify-content: space-between;
  font-size: 3vw;
  color: #666;
}

.dot {
  display: inline-block;
  margin-right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgb(239, 186, 143);
}

.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}

.releaseItem .imgBox span i {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}

.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 20px;
}

.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 2px solid #fff;
  padding: 10px 16px;
  border-radius: 16px;
  opacity: 0.9;
  font-size: 3vw;
  margin-left: auto;
}

.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 20px;
  background: #fff;
}

.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 20px;
}

.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}

.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}

.rightBox {
  width: calc(100% - 140px);
}

.top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}

.tags {
  display: flex;
  margin: 10px 0;
  flex-wrap: wrap;
}

.tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}

.yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}

.nameEllipsis {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.desc {
  color: rgb(153, 153, 153);
  font-size: 12px;
  margin: 5px 0;
}

.emptyBox {
  text-align: center;
  color: #999;
  font-size: 28px;
  padding: 60px 0;
}
</style>